export default "/images/database.svg?562a8409470b0f5086e6b76e14588b6a";